import React from 'react'
import { connect } from 'react-redux'

export default connect(
  (state) => ({
    logoURL: state.signupForm.addOrEdit.values.logoURL.value,
  }),
  null,
)(({ logoURL }) =>
  logoURL ? (
    <img
      alt="broken URL"
      src={logoURL}
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 300,
        display: 'block',
      }}
    />
  ) : null,
)
